<template>
  <div>
    <br />
    <div
      id="alert"
      class="alert alert-dismissible fade show m-alert m-alert--outline mb-4 mt-4"
      :class="alert.color"
      role="alert"
      v-if="alert.message"
      ref="alert"
    >
      <button type="button" class="close" aria-label="Close" @click="alert.message = ''"></button>
      <i :class="alert.icon"></i> &nbsp;<strong>{{ alert.message }}</strong
      ><br />
      {{ alert.reason }}
    </div>
    <div class v-if="data.response && data.response.length > 0">
      <a href data-toggle="modal" @click="download()">
        <button class="btn btn-outline-brand m-btn m-btn--outline">
          <i class="fas fa-download"></i> Baixar
        </button>
      </a>
    </div>
    <div class="row mb-3">
      <div class="col-md-6">
        <label for="billing_month"
          >Referente ao mês (mm/yyyy) <span class="m--font-danger">*</span></label
        >
        <div class="input-group">
          <input
            id="billing_month"
            type="text"
            ref="billing_month"
            class="form-control m-input"
            placeholder="mm/aaaa"
            v-model="data.billing_month"
            v-mask="'##/####'"
          />
        </div>
      </div>
      <div class="col-md-6">
        <div class="col-md-12">
          <label for="companies_month">
            Cliente
          </label>
          <SelectCustomers
            :selected="data.customers"
            :first="'Selecione um cliente'"
            @change="selectedCustomer($event)"
          />
        </div>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-md-12">
        <div class="m-portlet m-portlet--tab">
          <div class="m-portlet__body">
            <div class="table-responsive">
              <div class="container-table">
                <table class="table table-striped- table-bordered table-hover table-checkable">
                  <thead>
                    <tr>
                      <td
                        nowrap
                        class="text-center align-middle pointer"
                        width="60"
                        :class="{ 'table-sorted': sortType === 'id' }"
                        @click="sortCall('id')"
                      >
                        ID Contrato
                        <span
                          class="fas fa-caret-down sorted"
                          v-if="sortType === 'id' && !sortReverse"
                        ></span>
                        <span
                          class="fas fa-caret-up sorted"
                          v-if="sortType === 'id' && sortReverse"
                        ></span>
                        <span class="fal fa-sort sort" v-if="sortType != 'id'"></span>
                      </td>
                      <td nowrap class="text-center align-middle" width="200">Cliente</td>
                      <td nowrap class="text-center align-middle" width="100">
                        Ativos único contratados
                      </td>
                      <td nowrap class="text-center align-middle" width="100">
                        Ativos único utilizados
                      </td>
                      <td nowrap class="text-center align-middle" width="100">
                        Ativos campanha contratados
                      </td>
                      <td nowrap class="text-center align-middle" width="100">
                        Ativos campanha utilizados
                      </td>
                      <td nowrap class="text-center align-middle" width="100">
                        Ativos SMS contratados
                      </td>
                      <td nowrap class="text-center align-middle" width="100">
                        Ativos SMS utilizados
                      </td>
                      <td nowrap class="text-center align-middle" width="100">
                        Ativos campanha SMS contratados
                      </td>
                      <td nowrap class="text-center align-middle" width="100">
                        Ativos campanha SMS utilizados
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr></tr>
                    <tr v-for="(contract, id) in data.response" :key="id">
                      <td class="text-center align-middle">{{ contract.id }}</td>
                      <td class="text-left align-middle">
                        {{
                          contract.customer.customerable.co_name
                            ? contract.customer.customerable.co_name
                            : contract.customer.customerable.name
                        }}
                      </td>
                      <td class="text-center align-middle">
                        {{
                          contract.active_unique_contract ? contract.active_unique_contract : '-'
                        }}
                      </td>
                      <td class="text-center align-middle">
                        {{ contract.active_unique_used ? contract.active_unique_used : '-' }}
                      </td>
                      <td class="text-center align-middle">
                        {{
                          contract.active_campaign_contract
                            ? contract.active_campaign_contract
                            : '-'
                        }}
                      </td>
                      <td class="text-center align-middle">
                        {{ contract.active_campaign_used ? contract.active_campaign_used : '-' }}
                      </td>
                      <td class="text-center align-middle">
                        {{ contract.active_sms_contract ? contract.active_sms_contract : '-' }}
                      </td>
                      <td class="text-center align-middle">
                        {{ contract.active_sms_used ? contract.active_sms_used : '-' }}
                      </td>
                      <td class="text-center align-middle">
                        {{ contract.active_campaign_sms_contract ? contract.active_campaign_sms_contract : '-'  }}
                      </td>
                      <td class="text-center align-middle">
                        {{ contract.active_campaign_sms_used ? contract.active_campaign_sms_used : '-' }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div>
              <div class="paginator-info-bottom mt-2">
                <span class="m--font-gray" v-if="data.response.length > 0"
                  >Exibindo {{ data.response.length }} contratos.</span
                >
                <span class="m--font-gray" v-else>Nenhum item a ser exibido.</span>
              </div>
            </div>
            <div class="pt-4"></div>
          </div>
        </div>
      </div>
      <transition name="slideleft" mode="out-in">
        <CustomerModal v-if="showCustomerSave" @updateList="callData" />
      </transition>
      <transition name="fade" mode="out-in">
        <div
          class="m-quick-sidebar-overlay"
          v-if="showCustomerSave"
          @click="closeSaveContract()"
        ></div>
      </transition>
    </div>
  </div>
</template>

<script>
import CustomerModal from '@/components/customers/CustomerModal';
import SelectCustomers from '@/components/forms/SelectCustomers';
import { returnMessageMixin } from '@/mixins/returnMessageMixin';

import { baseApiUrl } from '@/global';
import axios from 'axios';

export default {
  mixins: [returnMessageMixin],
  name: 'ReportActives',
  props: ['start', 'finish'],
  components: { CustomerModal, SelectCustomers },
  data() {
    return {
      alert: {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: '',
        reason: '',
      },
      data: {
        billing_month: '',
        customers: '',
        response: [],
      },
      sortType: localStorage.customerSortType ? localStorage.customerSortType : 'id',
      sortReverse: localStorage.customerSortReverse ? localStorage.customerSortReverse : false,
      amount: localStorage.customerDataAmount ? localStorage.customerDataAmount : 100,
      page: localStorage.customerDataPage ? localStorage.customerDataPage : 1,
      filters: {
        id: localStorage.customerFilterId ? localStorage.customerFilterId : '',
        name: localStorage.customerFilterName ? localStorage.customerFilterName : '',
        cnpj: localStorage.customerFilterCnpj ? localStorage.customerFilterCnpj : '',
        status: localStorage.customerFilterStatus ? localStorage.customerFilterStatus : '',
      },
    };
  },
  computed: {
    loading() {
      return !this.data.current_page;
    },
    showCustomerSave() {
      return this.$store.state.showCustomerSave;
    },
  },
  methods: {
    clearAlert() {
      this.alert = {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: '',
        reason: '',
      };
    },
    download() {
      this.alert = {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: 'Gerando relatório',
        reason: '',
      };

      const url = `${baseApiUrl}/v1/customer/contract/actives/download/${this.convertFilters()}`;

      axios
        .get(url)
        .then((res) => {
          this.clearAlert();

          const arrData = res.data;

          let csvContent = 'data:text/csv;charset=utf-8,';
          csvContent += [
            Object.keys(arrData[0]).join(';'),
            ...arrData.map((item) => String(Object.values(item).join(';'))),
          ]
            .join('\n')
            .replace(/(^\[)|(\]$)/gm, '');

          const data = encodeURI(csvContent);
          const link = document.createElement('a');
          link.setAttribute('href', data);

          let fileName = `relatorio_ativos`;

          fileName += `_${this.data.billing_month}_cliente_${this.data.customers}`;

          fileName = `${fileName}.csv`;

          link.setAttribute('download', fileName);
          link.click();
        })
        .catch((error) => {
          this.logMessageFailed(error.response);
        });
    },
    generate() {
      this.callData();
    },
    setFilter(filterToChange, id) {
      this.filters[filterToChange] = id;
    },
    clearFilters() {
      this.filters.id = '';
      this.filters.name = '';
      this.filters.cnpj = '';
      this.filters.status = '';
      this.filters.sortType = 'id';
      this.filters.sortReverse = false;
      this.callData();
    },
    setStorageFilters() {
      localStorage.setItem('customerFilterId', this.filters.id);
      localStorage.setItem('customerFilterName', this.filters.name);
      localStorage.setItem('customerFilterCnpj', this.filters.cnpj);
      localStorage.setItem('customerFilterStatus', this.filters.status);
      localStorage.setItem('customerDataAmount', this.amount);
      localStorage.setItem('customerDataPage', this.page);
      localStorage.setItem('customerSortType', this.sortType);
      localStorage.setItem('customerSortReverse', this.sortReverse);
      localStorage.setItem('customerFilterMonth', this.filters.month);
    },
    convertFilters() {
      const filters = `?page=${this.page ? this.page : 1}&id=${
        this.filters.id ? this.filters.id : ''
      }&name=${this.filters.name ? this.filters.name : ''}&cnpj=${
        this.filters.cnpj ? this.filters.cnpj : ''
      }&status=${this.filters.status ? this.filters.status : ''}&amount=${this.amount}&sortType=${
        this.sortType
      }&month=${this.data.billing_month}&customers=${this.data.customers}&sortOrder=${
        this.sortReverse ? 'DESC' : 'ASC'
      }&start=${this.start}&end=${this.finish}`;

      return filters;
    },
    sortCall(sortType) {
      this.sortReverse = this.sortType == sortType ? !this.sortReverse : false;
      this.sortType = sortType;
    },
    callData() {
      this.data.current_page = 0;
      this.setStorageFilters();

      this.getDatas();
    },
    getDatas() {
      const url = `${baseApiUrl}/v1/customer/contract/actives/search/${this.convertFilters()}`;
      axios(url).then((res) => {
        this.data.response = res.data;

        this.$emit('updateLoading');
        if (res.data.current_page > res.data.last_page) {
          this.page = 1;
        }
      });
    },
    selectedCustomer(customersId) {
      this.data.customers = customersId;
    },
  },
  watch: {
    amount() {
      if (this.page == 1) {
        this.callData();
      } else {
        this.page = 1;
      }
    },
    page() {
      this.callData();
    },
    sortType() {
      this.callData();
    },
    sortReverse() {
      this.callData();
    },
  },
  mounted() {
    window.scroll(0, 0);
  },
};
</script>
